// extracted by mini-css-extract-plugin
export default {"paper":"FiltersActionPopper_paper__yJf5m","item":"FiltersActionPopper_item__BavS+","icon":"FiltersActionPopper_icon__GJ-9d"};